"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFramed = exports.applyTheme = void 0;
var _ApplicationContext = require("../ApplicationContext");
/* eslint-disable import/prefer-default-export */

const isFramed = () => window.self !== window.top;
exports.isFramed = isFramed;
const applyTheme = themeName => {
  const themeContainer = document.getElementById('theme-container');
  if (themeContainer) {
    const themeRegex = /^[a-zA-Z0-9_-]+$/;
    // themeContainer.className = '';
    if (themeName) {
      const normalizedThemeName = themeName.replace(/\s/g, '-');
      if (normalizedThemeName.match(themeRegex)) {
        themeContainer.classList.add(normalizedThemeName);
      }
    } else if (_ApplicationContext.ApplicationContext.getTheme()) {
      const normalizedAppThemeName = _ApplicationContext.ApplicationContext.getTheme().replace(/\s/g, '-');
      if (normalizedAppThemeName.match(themeRegex)) {
        themeContainer.classList.add(normalizedAppThemeName);
      }
    }
    if (isFramed()) {
      themeContainer.classList.add('framed');
    }
  }
};
exports.applyTheme = applyTheme;
//# sourceMappingURL=ThemeUtils.js.map